import React from 'react'
import { Modal } from 'antd'
import { Form, Icon, Input, Button, Row, Col } from 'antd'
import { notification } from 'antd'
import InputPhone from 'components/InputPhone'
import { Types } from 'store/actions/auth'

import UserSignUp from '../SignUp'

import imgLogo from 'assets/spiffme_600px.png'
import './styles.css'

const FormItem = Form.Item

const formItemLayout = {
  labelCol: {
    xs: { span: 1 }
  },
  wrapperCol: {
    xs: { span: 23 }
  },
  colon: false
}

class NewManufacturer extends React.Component {
  state = {
    visible: true,
    isUserSignUp: true,
    companyData: {},
    userData: {}
  }

  onClose = () => {
    this.setState({ visible: false })
    setTimeout(() => this.props.changeRoute('/'), 300)
  }

  checkPassword = (rule, value, callback) => {
    const form = this.props.form
    if (value && value !== form.getFieldValue('password')) {
      callback('Two passwords that you enter is inconsistent!')
    } else {
      callback()
    }
  }

  checkConfirm = (rule, value, callback) => {
    const form = this.props.form
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true })
    }
    callback()
  }

  onUserInformation = data => {
    this.setState({
      userData: data,
      isUserSignUp: false
    })
  }

  onBack = data => {
    const { getFieldsValue } = this.props.form

    this.setState({
      isUserSignUp: true,
      companyData: getFieldsValue()
    })
  }

  handleSubmit = e => {
    e.preventDefault()
    const { validateFields } = this.props.form

    validateFields((err, values) => {
      if (err) {
        notification['error']({
          message: 'Validation Error',
          description: 'Please enter correct information.',
          duration: 3
        })
      } else {
        const data = {
          ...values
        }

        this.setState({ companyData: data })
        this.props.createManufacturer(data, this.state.userData)
      }
    })
  }

  render () {
    const { getFieldDecorator } = this.props.form
    const { global } = this.props
    const { isUserSignUp, visible, userData, companyData } = this.state

    if (isUserSignUp === true) {
      return <UserSignUp data={userData} onSubmit={this.onUserInformation} />
    }

    return (
      <Modal
        wrapClassName='vertical-center-modal'
        visible={visible}
        footer={null}
        onCancel={this.onClose}
      >
        <div className='signup'>
          <img className='logo' src={imgLogo} alt='logo' />
          <p className='description'>
            You are almost finished.
            <br />
            We just need the information below about your company.
            <br />
            Fields marked with a <span style={{ color: '#f5222d' }}>*</span> are
            required.
          </p>

          <div className='form'>
            <Form onSubmit={this.handleSubmit}>
              <FormItem {...formItemLayout} label=' '>
                {getFieldDecorator('name', {
                  initialValue: companyData.name,
                  rules: [
                    { required: true, message: 'Please input company name!' }
                  ]
                })(
                  <Input
                    prefix={<Icon type='idcard' />}
                    placeholder='Company Name'
                  />
                )}
              </FormItem>
              <FormItem
                {...formItemLayout}
                label=' '
                style={{ marginBottom: 0 }}
              >
                {getFieldDecorator('address1', {
                  initialValue: companyData.address1,
                  rules: [
                    { required: true, message: 'Please input the address!' }
                  ]
                })(
                  <Input
                    prefix={<Icon type='home' />}
                    placeholder='Address Line 1'
                  />
                )}
              </FormItem>
              <FormItem
                {...formItemLayout}
                label=' '
                style={{ marginBottom: 0 }}
              >
                {getFieldDecorator('address2', {
                  initialValue: companyData.address2
                })(
                  <Input
                    prefix={<Icon type='' />}
                    placeholder='Address Line 2'
                  />
                )}
              </FormItem>
              <FormItem
                {...formItemLayout}
                label=' '
                style={{ marginBottom: 0 }}
              >
                {getFieldDecorator('city', {
                  initialValue: companyData.city,
                  rules: [{ required: true, message: 'Please input City!' }]
                })(
                  <Input
                    prefix={<Icon type='pushpin-o' />}
                    placeholder='City'
                  />
                )}
              </FormItem>
              <FormItem
                {...formItemLayout}
                label=' '
                style={{ marginBottom: 0 }}
              >
                {getFieldDecorator('state', {
                  initialValue: companyData.state,
                  rules: [{ required: true, message: 'Please input State!' }]
                })(
                  <Input
                    prefix={<Icon type='pushpin-o' />}
                    placeholder='State'
                  />
                )}
              </FormItem>
              <FormItem {...formItemLayout} label=' '>
                {getFieldDecorator('zipcode', {
                  initialValue: companyData.zipcode,
                  rules: [{ required: true, message: 'Please input ZIP Code!' }]
                })(
                  <Input
                    prefix={<Icon type='pushpin-o' />}
                    placeholder='ZIP Code'
                  />
                )}
              </FormItem>
              <FormItem {...formItemLayout} label=' '>
                {getFieldDecorator('email', {
                  initialValue: companyData.email,
                  rules: [
                    {
                      type: 'email',
                      message: 'The input is not valid E-mail!'
                    },
                    {
                      required: true,
                      message: 'Please input State!'
                    }
                  ]
                })(
                  <Input
                    prefix={<Icon type='mail' />}
                    placeholder='Company E-mail'
                  />
                )}
              </FormItem>
              <FormItem {...formItemLayout} label=' '>
                {getFieldDecorator('phone', {
                  initialValue: companyData.phone
                })(<InputPhone placeholder='Company Phone Number' />)}
              </FormItem>
              <FormItem {...formItemLayout} label=' '>
                {getFieldDecorator('website', {
                  initialValue: companyData.website,
                  rules: []
                })(
                  <Input
                    prefix={<Icon type='laptop' />}
                    placeholder='Company Website'
                  />
                )}
              </FormItem>
              <FormItem
                {...formItemLayout}
                label=' '
                style={{ marginBottom: 36, marginTop: 36 }}
              >
                <Row gutter={16}>
                  <Col span={12}>
                    <Button
                      size='large'
                      ghost
                      className='form-button'
                      onClick={this.onBack}
                    >
                      Back
                    </Button>
                  </Col>
                  <Col span={12}>
                    <Button
                      size='large'
                      ghost
                      htmlType='submit'
                      className='form-button'
                      loading={
                        global.status[Types.CREATE_MANUFACTURER] === 'request'
                      }
                    >
                      Create
                    </Button>
                  </Col>
                </Row>
              </FormItem>
            </Form>
          </div>
        </div>
      </Modal>
    )
  }
}

export default Form.create()(NewManufacturer)
